/**
 * This function convert object to query params
 * @param {Object} queryObject
 */
export default function objectToQueryParams(queryObject) {
	return Object.entries(queryObject)
		.map(([key, val]) => `${key}=${val}`)
		.join('&');
}
